import script from "./CardBig.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBig.vue?vue&type=script&setup=true&lang=js"

import "./CardBig.vue?vue&type=style&index=0&id=4c38ffc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c38ffc4"]])

export default __exports__